module.exports = __webpack_public_path__ + "static/screenshot3-66610984ca8f701d5dd5789e4d8c6011.png";